/**
 * LIGHTNING ⚡ ARENA — bootstrap
 * Quake 3 Arena style Lightning deathmatch. See game/game.ts.
 */
import { Game } from './game/game';

function setLoading(text: string, pct: number): void {
  const t = document.getElementById('loading-text'); if (t) t.textContent = text;
  const b = document.getElementById('progress-bar') as HTMLElement | null; if (b) b.style.width = `${pct}%`;
}

function fail(msg: string): void {
  const err = document.getElementById('error'); const m = document.getElementById('error-message');
  if (m) m.textContent = msg;
  if (err) err.style.display = 'flex';
  document.getElementById('loading')?.remove();
}

async function boot(): Promise<void> {
  try {
    setLoading('Forging the Lightning Yard…', 30);
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2');
    if (!gl) throw new Error('WebGL2 is required. Update your browser or enable hardware acceleration.');
    setLoading('Spawning legends…', 70);
    const game = new Game();
    (window as any).doomArena = game;
    setLoading('Ready', 100);
    requestAnimationFrame(() => document.getElementById('loading')?.remove());
  } catch (e) {
    console.error(e);
    fail(e instanceof Error ? e.message : String(e));
  }
}

boot();